import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ShowRoundsQuery, ShowRoundsResponse } from './show-round.model';

/**
 * TVG-337: HTTP wrapper for the business-wide show rounds list.
 *
 * Read-only — rounds are booked on the event, never here. Gated server-side on
 * the `crm-sales-flow` toggle (404 when off).
 */
@Injectable({
  providedIn: 'root',
})
export class ShowRoundService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  list(query: ShowRoundsQuery = {}): Observable<ShowRoundsResponse> {
    let params = new HttpParams();

    if (query.search) {
      params = params.set('search', query.search);
    }

    if (query.venueId != null) {
      params = params.set('venue_id', query.venueId);
    }

    if (query.pageNum != null) {
      params = params.set('pageNum', query.pageNum);
    }

    if (query.pageSize != null) {
      params = params.set('pageSize', query.pageSize);
    }

    return this.http.get<ShowRoundsResponse>(`${this.apiUrl}/api/show-rounds`, { params });
  }
}
